import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'styled-components';
import Icon from '../Icon';

const SplashScreenContainer = styled('div')`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70vh;
`;

const AppIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const SplashScreen = ({ icon }) => (
  <SplashScreenContainer>
    <CircularProgress size={56} />
    <AppIcon icon={['fal', icon || 'home']} color="action" />
  </SplashScreenContainer>
);

SplashScreen.defaultProps = {
  icon: undefined,
};

SplashScreen.propTypes = {
  icon: PropTypes.string,
};

export default SplashScreen;
